export default [
  'MI-ONE PLUS',
  'MI-ONE C1',
  'MI-ONE',
  // '2012051',
  // '2012053',
  // '2012052',
  // '2012061',
  // '2012062',
  // '2013012',
  // '2013021',
  // '2012121',
  // '2013061',
  // '2013062',
  // '2013063',
  // '2014215',
  // '2014218',
  // '2014216',
  // '2014719',
  // '2014716',
  // '2014726',
  // '2015015',
  // '2015561',
  // '2015562',
  // '2015911',
  // '2015201',
  // '2015628',
  // '2015105',
  // '2015711',
  // '2016070',
  // '2016089',
  'MDE2',
  'MDT2',
  'MCE16',
  'MCT1',
  'M1804D2SE',
  'M1804D2ST',
  'M1804D2SC',
  'M1803E1A',
  'M1803E1T',
  'M1803E1C',
  'M1807E8S',
  'M1807E8A',
  'M1805E2A',
  'M1808D2TE',
  'M1808D2TT',
  'M1808D2TC',
  'M1808D2TG',
  'M1902F1A',
  'M1902F1T',
  'M1902F1C',
  'M1902F1G',
  'M1908F1XE',
  'M1903F2A',
  'M1903F2G',
  'M1903F10G',
  'M1903F11G',
  'M1904F3BG',
  'M2001J2E',
  'M2001J2C',
  'M2001J2G',
  'M2001J2I',
  'M2001J1E',
  'M2001J1C',
  'M2001J1G',
  'M2002J9E',
  'M2002J9G',
  'M2002J9S',
  'M2002J9R',
  'XIG01',
  'M2007J1SC',
  'M2007J3SY',
  'M2007J3SP',
  'M2007J3SG',
  'M2007J3SI',
  'M2007J17G',
  'M2007J17I',
  'M2102J2SC',
  'M2011K2C',
  'M2011K2G',
  'M2102K1AC',
  'M2102K1C',
  'M2102K1G',
  'M2101K9C',
  'M2101K9G',
  'M2101K9R',
  'M2101K9AG',
  'M2101K9AI',
  '2107119DC',
  '2109119DG',
  '2109119DI',
  'M2012K11G',
  'M2012K11AI',
  'M2012K11I',
  '21081111RG',
  '2107113SG',
  '2107113SI',
  '2107113SR',
  '21091116I',
  '21091116UI',
  '2201123C',
  '2201123G',
  '2112123AC',
  '2112123AG',
  '2201122C',
  '2201122G',
  '2207122MC',
  '2203129G',
  '2203129I',
  '2206123SC',
  '2206122SC',
  '2203121C',
  '22071212AG',
  '22081212UG',
  '22081212R',
  '22200414R',
  'A201XM',
  '2211133C',
  '2211133G',
  '2210132C',
  '2210132G',
  '2304FPN6DC',
  '2304FPN6DG',
  '2210129SG',
  '2306EPN60G',
  '2306EPN60R',
  'XIG04',
  '23078PND5G',
  '23088PND5R',
  'A301XM',
  '23127PN0CC',
  '23127PN0CG',
  '23116PN5BC',
  '2311BPN23C',
  '24031PN0DC',
  '24030PN60G',
  '24053PY09I',
  '2406APNFAG',
  'XIG07',
  '2407FPN8EG',
  '2407FPN8ER',
  'XIG06',
  'A402XM',
  '24129PN74C',
  '24129PN74G',
  '24129PN74I',
  '2410DPN6CC',
  '25019PNF3C',
  '25010PN30C',
  '25010PN30G',
  '25010PN30I',
  '25042PN24C',
  '25069PTEBG',
  '2506BPN68G',
  '2506BPN68R',
  '25113PN0EC',
  '25113PN0EG',
  '25113PN0EI',
  '25098PN5AC',
  '2509FPN0BC',
  'A0101',
  '2015716',
  'MCE91',
  'M1806D9W',
  'M1806D9E',
  'M1806D9PE',
  '21051182C',
  '21051182G',
  'M2105K81AC',
  'M2105K81C',
  '22081281AC',
  '23043RP34C',
  '23043RP34G',
  '23043RP34I',
  '23046RP50C',
  '2307BRPDCC',
  '24018RPACC',
  '24018RPACG',
  '2410CRP4CC',
  '2410CRP4CG',
  '24091RPADC',
  '24091RPADG',
  '25032RP42C',
  '25053RP5CC',
  '25079RPDCG',
  '25097RP43C',
  '25097RP43G',
  '25097RP43I',
  '25091RP04C',
  '25091RP04G',
  // '2013022',
  // '2013023',
  // '2013029',
  // '2013028',
  // '2014011',
  // '2014501',
  // '2014813',
  // '2014112',
  // '2014811',
  // '2014812',
  // '2014821',
  // '2014817',
  // '2014818',
  // '2014819',
  // '2014502',
  // '2014512',
  // '2014055',
  // '2014816',
  // '2015811',
  // '2015815',
  // '2015812',
  // '2015810',
  // '2015817',
  // '2015819',
  // '2015818',
  // '2015816',
  // '2016030',
  // '2016031',
  // '2016032',
  // '2016037',
  // '2016036',
  // '2016035',
  // '2016033',
  // '2016090',
  // '2016060',
  // '2016111',
  // '2016112',
  // '2016117',
  // '2016116',
  'MAE136',
  'MAT136',
  'MAG138',
  'MAI132',
  'MDE1',
  'MDT1',
  'MDG1',
  'MDI1',
  'MEE7',
  'MET7',
  'MEG7',
  'MCE3B',
  'MCT3B',
  'MCG3B',
  'MCI3B',
  'M1804C3DE',
  'M1804C3DT',
  'M1804C3DC',
  'M1804C3DG',
  'M1804C3DH',
  'M1804C3DI',
  'M1805D1SE',
  'M1805D1ST',
  'M1805D1SC',
  'M1805D1SI',
  'M1804C3CE',
  'M1804C3CT',
  'M1804C3CC',
  'M1804C3CG',
  'M1804C3CH',
  'M1804C3CI',
  'M1810F6LE',
  'M1810F6LT',
  'M1810F6LG',
  'M1810F6LH',
  'M1810F6LI',
  'M1903C3EE',
  'M1903C3ET',
  'M1903C3EC',
  'M1903C3EG',
  'M1903C3EH',
  'M1903C3EI',
  'M1908C3IE',
  'M1908C3IC',
  'M1908C3IG',
  'M1908C3IH',
  'M1908C3II',
  'M1908C3KE',
  'M1908C3KG',
  'M1908C3KH',
  'M1908C3KI',
  'M2001C3K3I',
  'M2004J19C',
  'M2004J19G',
  'M2004J19I',
  'M2004J19AG',
  'M2006C3LC',
  'M2006C3LG',
  'M2006C3LVG',
  'M2006C3LI',
  'M2006C3LII',
  'M2006C3MG',
  'M2006C3MT',
  'M2006C3MNG',
  'M2006C3MII',
  'M2010J19SG',
  'M2010J19SI',
  'M2010J19SR',
  'M2010J19ST',
  'M2010J19SY',
  'M2010J19SL',
  '21061119AG',
  '21061119AL',
  '21061119BI',
  '21061119DG',
  '21121119SG',
  '21121119VL',
  '22011119TI',
  '22011119UY',
  '22041219G',
  '22041219I',
  '22041219NY',
  '220333QAG',
  '220333QBI',
  '220333QNY',
  '220333QL',
  '220233L2C',
  '220233L2G',
  '220233L2I',
  '22071219AI',
  '23053RN02A',
  '23053RN02I',
  '23053RN02L',
  '23053RN02Y',
  '23077RABDC',
  '23076RN8DY',
  '23076RA4BR',
  'XIG03',
  'A401XM',
  '23076RN4BI',
  '23076RA4BC',
  '22120RN86C',
  '22120RN86G',
  '22120RN86H',
  '22120RN86I',
  '2212ARNC4L',
  '22126RN91Y',
  '2404ARN45A',
  '2404ARN45I',
  '24049RN28L',
  '24040RN64Y',
  '2406ERN9CI',
  '23106RN0DA',
  '2311DRN14I',
  '23100RN82L',
  '23108RN04Y',
  '23124RN87C',
  '23124RN87I',
  '23124RN87G',
  '2409BRN2CC',
  '2409BRN2CA',
  '2409BRN2CI',
  '2409BRN2CL',
  '2409BRN2CY',
  '2411DRN47G',
  '2411DRN47R',
  '2411DRN47C',
  '2411DRN47I',
  '25062RN2DA',
  '25062RN2DY',
  '25062RN2DE',
  '25062RN2DL',
  '25057RN09G',
  '25057RN09E',
  '25057RN09I',
  '25078RA3EA',
  '25078RA3EY',
  '25078RA3EE',
  '25078RA3EL',
  '2508CRN2BC',
  '2508CRN2BG',
  '2508CRN2BE',
  '2508CRN2BI',
  '2508CRN2BR',
  '25082RNC1C',
  // '2014018',
  // '2013121',
  // '2014017',
  // '2013122',
  // '2014022',
  // '2014021',
  // '2014715',
  // '2014712',
  // '2014915',
  // '2014912',
  // '2014916',
  // '2014911',
  // '2014910',
  // '2015052',
  // '2015051',
  // '2015712',
  // '2015055',
  // '2015056',
  // '2015617',
  // '2015611',
  // '2015112',
  // '2015115',
  // '2015116',
  // '2015161',
  // '2016050',
  // '2016051',
  // '2016101',
  // '2016130',
  // '2016100',
  // '2016102',
  'MBE6A5',
  'MBT6A5',
  'MEI7',
  'MEE7S',
  'MET7S',
  'MEC7S',
  'M1803E7SG',
  'M1803E7SH',
  'MEI7S',
  'MDE6',
  'MDT6',
  'MDG6',
  'MDI6',
  'MDE6S',
  'MDT6S',
  'MDG6S',
  'MDI6S',
  'M1806E7TG',
  'M1806E7TH',
  'M1806E7TI',
  'M1901F7E',
  'M1901F7T',
  'M1901F7C',
  'M1901F7G',
  'M1901F7H',
  'M1901F7I',
  'M1901F7BE',
  'M1901F7S',
  'M1908C3JE',
  'M1908C3JC',
  'M1908C3JG',
  'M1908C3JH',
  'M1908C3JI',
  'M1908C3XG',
  'M1908C3JGG',
  'M1906G7E',
  'M1906G7T',
  'M1906G7G',
  'M1906G7I',
  'M2010J19SC',
  'M2007J22C',
  'M2003J15SS',
  'M2003J15SI',
  'M2003J15SG',
  'M2007J22G',
  'M2007J22R',
  'A001XM',
  'M2007J17C',
  'M2003J6A1G',
  'M2003J6A1R',
  'M2003J6A1I',
  'M2003J6B1I',
  'M2003J6B2G',
  'M2101K7AG',
  'M2101K7AI',
  'M2101K7BG',
  'M2101K7BI',
  'M2101K7BNY',
  'M2101K7BL',
  'M2103K19C',
  'M2103K19I',
  'M2103K19G',
  'M2103K19Y',
  'M2104K19J',
  'XIG02',
  '22021119KR',
  'A101XM',
  'M2101K6G',
  'M2101K6T',
  'M2101K6R',
  'M2101K6P',
  'M2101K6I',
  'M2104K10AC',
  '2109106A1I',
  '21121119SC',
  '2201117TG',
  '2201117TI',
  '2201117TL',
  '2201117TY',
  '21091116AC',
  '21091116AI',
  '22041219C',
  '2201117SG',
  '2201117SI',
  '2201117SL',
  '2201117SY',
  '22087RA4DI',
  '22031116BG',
  '21091116C',
  '2201116TG',
  '2201116TI',
  '2201116SC',
  '2201116SG',
  '2201116SR',
  '2201116SI',
  '21091116UC',
  '21091116UG',
  '22041216C',
  '22041216UC',
  '22095RA98C',
  '23021RAAEG',
  '23027RAD4I',
  '23028RA60L',
  '23021RAA2Y',
  '22101317C',
  '22111317G',
  '22111317I',
  '23076RA4BC',
  '2303CRA44A',
  '2303ERA42L',
  '23030RAC7Y',
  '2209116AG',
  '22101316C',
  '22101316G',
  '22101316I',
  '22101316UCP',
  '22101316UG',
  '22101316UP',
  '22101316UC',
  '22101320C',
  '23054RA19C',
  '23049RAD8C',
  '23129RAA4G',
  '23129RA5FL',
  '23124RA7EO',
  '2312DRAABC',
  '2312DRAABI',
  '2312DRAABG',
  '23117RA68G',
  '2312DRA50C',
  '2312DRA50G',
  '2312DRA50I',
  'XIG05',
  '2312CRAD3C',
  '23090RA98C',
  '23090RA98G',
  '23090RA98I',
  '24040RA98R',
  '2406ERN9CC',
  '2311FRAFDC',
  '24117RN76G',
  '24117RN76E',
  '24117RN76L',
  '24117RN76O',
  '24094RAD4C',
  '24094RAD4I',
  '24094RAD4G',
  '2502FRA65G',
  '24116RACCG',
  '24090RA29C',
  '24090RA29G',
  '24090RA29I',
  '24115RA8EC',
  '24115RA8EG',
  '24115RA8EI',
  '25098RA98C',
  '25098RA98G',
  '25098RA98E',
  '25098RA98I',
  '25080RABDC',
  '25080RABDG',
  '25080RABDI',
  '25080RABDR',
  '2510ERA8BC',
  '2510ERA8BG',
  '2510ERA8BI',
  '25104RADAC',
  '25057RA09C',
  'M2004J7AC',
  'M2004J7BC',
  'M2003J15SC',
  '24069RA21C',
  '24129RT7CC',
  '25053RT47C',
  'M1903F10A',
  'M1903F10C',
  'M1903F10I',
  'M1903F11A',
  'M1903F11C',
  'M1903F11I',
  'M1903F11A',
  'M2001G7AE',
  'M2001G7AC',
  'M2001G7AC',
  'M1912G7BE',
  'M1912G7BC',
  'M2001J11C',
  'M2001J11C',
  'M2001J11E',
  'M2006J10C',
  'M2007J3SC',
  'M2012K11AC',
  'M2012K11C',
  'M2012K11C',
  'M2012K10C',
  '22021211RC',
  '22041211AC',
  '22011211C',
  '21121210C',
  '22081212C',
  '22041216I',
  '23013RK75C',
  '22127RK46C',
  '22122RK93C',
  '23078RKD5C',
  '23113RKC6C',
  '23117RK66C',
  '2311DRK48C',
  '2407FRK8EC',
  '24117RK2CC',
  '24122RKC7C',
  '24127RK2CC',
  '25060RK16C',
  '2510DRK44C',
  '25102RKBEC',
  '25102RK69C',
  '2016020',
  '2016021',
  'M1803E6E',
  'M1803E6T',
  'M1803E6C',
  'M1803E6G',
  'M1803E6H',
  'M1803E6I',
  'M1810F6G',
  'M1810F6I',
  'M1903C3GG',
  'M1903C3GH',
  'M1903C3GI',
  '220733SG',
  '220733SH',
  '220733SI',
  '220733SL',
  '220733SFG',
  '220733SFH',
  '220743FI',
  '23028RN4DG',
  '23028RN4DH',
  '23028RN4DI',
  '23026RN54G',
  '23028RNCAG',
  '23028RNCAH',
  '23028RNCAI',
  '23129RN51H',
  '2312CRNCCL',
  '24048RN6CG',
  '24048RN6CI',
  '24044RN32L',
  '2409BRN2CG',
  '24116RNC1I',
  '25028RN03G',
  '25028RN03A',
  '25028RN03Y',
  '25028RN03I',
  '25028RN03L',
  '22081283C',
  '22081283G',
  '23073RPBFC',
  '23073RPBFG',
  '23073RPBFL',
  '23073RPBFC',
  '2405CRPFDC',
  '2405CRPFDG',
  '2405CRPFDI',
  '2405CRPFDL',
  '24074RPD2C',
  '24074RPD2G',
  '24074RPD2I',
  '24075RP89G',
  '24076RP19G',
  '24076RP19I',
  '25040RP0AC',
  '25040RP0AG',
  '25040RP0AI',
  '25040RP0AE',
  '25040RP0AL',
  '2505DRP06G',
  '2505DRP06I',
  '2505DRP06E',
  '25099RP13C',
  '25099RP13G',
  '25099RP13I',
  '2509BRP2DC',
  '2509BRP2DG',
  '2509BRP2DI',
  '25079RPDCC',
]